<section class="content">
    <div class="container-fluid">
        <div class="block-header">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <ul class="breadcrumb breadcrumb-style ">
                        <li class="breadcrumb-item">
                            <h4 class="page-title">Basic Form</h4>
                        </li>
                        <li class="breadcrumb-item bcrumb-1">
                            <a routerLink="/dashboard/main">
                                <i class="fas fa-home"></i> Home</a>
                        </li>
                        <li class="breadcrumb-item bcrumb-2">
                            <a href="#" onClick="return false;">Forms</a>
                        </li>
                        <li class="breadcrumb-item active">Basic</li>
                    </ul>
                </div>
            </div>
        </div>
        <app-maser-page-header></app-maser-page-header>
        <br>
        <div class="form-row">
            <div class="col-2"></div>
            <div class="col">
                <input type="text" class="form-control code_box" [(ngModel)]="icustomer_mobile"
                    placeholder="icustomer phone number">
            </div>
            <div class="col-1 text-center">or</div>
            <div class="col">
                <input type="text" class="form-control code_box" [(ngModel)]="icustomer_code" placeholder="icustomer code">
            </div>
            <div class="col">
                <button mat-raised-button color="primary" (click)="getIcustomerDetails()">Confirm
                </button>
            </div>
        </div>
        <div *ngIf="icustomer_verified" style="padding:13px">
            <div class="card" style="margin-top: 15px; padding: 20px;">
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col text-center" style="font-weight: 600; font-size: 18px;">
                        Customer Details
                    </div>
                    <div class="col-2"></div>
                </div>
                <hr>
                <div class="row" style="padding:10px">
                    <div class="col-1">
                    </div>
                    <div class="col">
                        <b>Name</b> : {{ icustomer_detail['first_name'] }} {{ icustomer_detail['last_name'] }}
                    </div>
                    <div class="col">
                        <b>Mobile</b> : {{ icustomer_detail['mobile'] }}
                    </div>
                    <div class="col">
                        <b>Type</b> : {{ icustomer_detail['customer_type_name'] }}
                    </div>
                    <div class="col">

                    </div>
                </div>
                <div class="row" style="padding:10px">
                    <div class="col-1">
                    </div>
                    <div class="col">
                        <b>Address</b> : {{ icustomer_detail['address'] }}
                    </div>
                    <div class="col">
                        <b>Taluk</b> : {{ icustomer_detail['taluk'] }}
                    </div>
                    <div class="col">
                        <b>District</b> : {{ icustomer_detail['district'] }} - {{ icustomer_detail['pincode'] }}
                    </div>
                    <div class="col">
                        <img [src]="icustomer_detail['image']" *ngIf="icustomer_detail['image'] != null"
                            style="height: 100px; width: 100px; position: absolute; margin-top: -69px;">
                    </div>
                </div>
            </div>
        </div>
        <div class="card" *ngFor="let log of transaction_log; let odd_index=odd" style="padding: 26px; width: 50%;">
            <div class="row">
                <div class="col" style="font-size:15px">
                    <span *ngIf="log['transaction_direction_id'] == 1 "
                        style="font-weight: bold; font-size: initial;">Payment</span>
                    <span *ngIf="log['transaction_direction_id'] == 2 "
                        style="font-weight: bold; font-size: initial;">Payment</span>
                    <span *ngIf="log['transaction_direction_id'] == 3 "
                        style="font-weight: bold; font-size: initial;">Refund</span>
                    <span style="font-weight: 600;">{{log['transaction_direction_description']}}</span>
                </div>
                <div class="col-5" style="text-align: right;">
                    Amount : {{log['amount'] | currency:'INR'}} <br>
                </div>
            </div>
            <div class="row">
                <div class="col-6" style="text-align: left; font-size: 12px;">
                   Month of Order : {{log['time_created'] | date:'MMM'}}
                </div>
                <div class="col" style="text-align: right;">
                    Wallet Balance Before : {{log['wallet_balance_before'] | currency:'INR'}} <br>
                </div>
                <div class="col" style="text-align: right;">
                    Wallet Balance After : {{log['wallet_balance_after'] | currency:'INR'}} <br>
                </div>
            </div>
            <div class="row">
                <div class="col-4" style="text-align: left; font-size: 12px;">
                    payment Mode : {{log['transaction_mode_name']}}
                </div>
            </div>
        </div>
    </div>
</section>
